import { LiaUserCheckSolid } from "react-icons/lia";

const TempCustomer = () => {
    return (
        <div className="temp-container" >
            <div className="card border-0 shadow-lg rounded-5 overflow-hidden" style={{ maxWidth: "500px", width: "100%", }} >
                <div className="card-body text-center p-5" >
                    <div className="mb-4">
                        <div className="rounded-circle d-inline-flex align-items-center justify-content-center p-4 profile-icon" >
                            <LiaUserCheckSolid  className="text-white fs-2" />
                        </div>
                    </div>

                    <span className="badge rounded-pill px-3 py-2 mb-3 verification-badge" >Verification In Progress</span>
                    <h2 className="fw-bold mb-3" >Your Profile is Under Review</h2>
                    <p className="text-secondary mb-4" >
                        Thank you for submitting your details. Our team is
                        currently verifying your profile. This process usually
                        takes only a short time. You will receive a notification
                        as soon as your profile has been approved.
                    </p>
                    <div className="mb-4">
                        <div className="progress rounded-pill" >
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                style={{
                                    width: "70%",
                                    backgroundColor: "#ff6200",
                                }}
                            />
                        </div>
                    </div>
                    <div className="border-top pt-3">
                        <small className="text-muted">
                            Please wait while we complete the verification
                            process.
                        </small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TempCustomer;